$( document ).ready(function() {

  if($(window).width() < 767){
    jQuery('#ProductForm__BuyButtons_pre_button').click(function(e) {
      var jump = jQuery('.title_price_sec');
      var new_position = jQuery(jump).offset();
      jQuery('html, body').stop().animate({ scrollTop: new_position.top }, 500);
      e.preventDefault();
    });
  }
  
  /* scroll to target */
  jQuery('.scrollTo').click(function(e) {
    var jump = jQuery(this).attr('href');
    var new_position = jQuery(jump).offset();
    jQuery('html, body').stop().animate({ scrollTop: new_position.top - 25 }, 800, function(){
        var new_position = jQuery(jump).offset();
        jQuery('html, body').stop().animate({ scrollTop: new_position.top - 25 }, 500);
    });
    e.preventDefault();
  });
  
  // product-shipping-info-section{}
   $('.row').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
          }
        }
      ]
    }); 

  
  
  $('.banner-slider, .midl-banner-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 7000
  });
  
  $('.category-slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    adaptiveHeight: true,
    lazyLoad: 'progressive',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  });

  
  $('.fav-product-slider').slick({
    infinite: false,
    // slidesToShow: 3.7,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          // slidesToShow: 3.7,
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          // slidesToShow: 2.7,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          // slidesToShow: 1.5,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  
  $('.shop-look-slider').slick({
    infinite: false,
    slidesToShow: 2.3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1
        }
      }
    ]
  });

  
  $('.blog-slider').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1
        }
      }
    ]
  });

  
  $('.cust-review-slider').slick({
    infinite: false,
    slidesToShow: 3.2,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1
        }
      }
    ]
  });

  
  // $('.shipping-slider').slick({
  //   infinite: false,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   dots: false,
  //   arrows: false,
  //   responsive: [
  //     {
  //       breakpoint: 1199,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 1,
  //         arrows: true,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });

    
  // $('.icon-text-row').slick({
  //   infinite: false,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   dots: false,
  //   arrows: true,
  //   responsive: [
  //     {
  //       breakpoint: 1199,
  //       settings: {
  //         slidesToShow: 6,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         slidesToShow: 5,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });

    
  $('.featured-on-slider').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
    
  $('.shop-color-row').slick({
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  // $('.collection_bubble_section .cb_inner_grid').slick({
  //   infinite: false,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   dots: false,
  //   arrows: true,
  //   responsive: [
  //     {
  //       breakpoint: 1199,
  //       settings: {
  //         slidesToShow: 5,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });


  $('.product-custom-gallery-section .product-custom-gallery').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  

  
  $('.section-cntent-prod').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplayspeed: 3000,
    dots: false,
    arrows: false,
  });
    
  // $('.related-products .product-grid').slick({
  //   infinite: false,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   dots: false,
  //   arrows: true,
  //   responsive: [
  //     {
  //       breakpoint: 1199,
  //       settings: {
  //         slidesToShow: 4,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 767,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });
  


  // Read More Read Less JS start
  $(".readmore_button").click(function() {
    var elem = $(this).text();
    // console.log(elem);
    if (elem == "Read More") {
      $(this).text("Read Less");
      $(".collection-description").addClass('fullHeight');
    } else {
      $(this).text("Read More");
      $(".collection-description").removeClass('fullHeight');
    }
  });

  // Megamenu click js start
  $(".header .header__inline-menu li:first-child .icon-caret , .header .header__inline-menu li:first-child .mega-menu-list").click(function(e) {
    e.stopPropagation();
    $("header .header__inline-menu .header-megamenu-wrapper").toggleClass("megamenu-opened");
    $(".header .header__inline-menu li:first-child .icon-caret").toggleClass("rotatee");
  });
  $("header .header__inline-menu .header-megamenu-wrapper").click(function(e) {
    e.stopPropagation();
  });

  $(document).on('click',function(e){
    $("header .header__inline-menu .header-megamenu-wrapper").removeClass("megamenu-opened");
    $(".header .header__inline-menu li:first-child .icon-caret").removeClass("rotatee");
  });
  

  // FAQ section JS start
  $(".faq-section .accordion_head").click(function () {      
    if ($('.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $(".plusminus").text('+');
    }
    if ($(this).next(".accordion_body").is(':visible')) {
      $(this).next(".accordion_body").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion_body").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
  
  
  // Mobile menu JS start
  $(".m-mega-menu-wrapper li .megamenu-head").click(function () {      
    if ($('.megamenu-content').is(':visible')) {
      $(".megamenu-content").slideUp(300);
      $(".plusminus").text('+').css('font-size', '22px');
    }
    if ($(this).next(".megamenu-content").is(':visible')) {
      $(this).next(".megamenu-content").slideUp(300);
      $(this).children(".plusminus").text('+').css('font-size', '22px');
    } else {
      $(this).next(".megamenu-content").slideDown(300);
      $(this).children(".plusminus").text('-').css('font-size' , '34px');
    }
  });  

  // Mega Menu Mobile menu JS start
  $(".new-mobile-menu li .menu-head").click(function () {      
    if ($('.m-menu-content').is(':visible')) {
      $(".m-menu-content").slideUp(300);
      $(".arrow").removeClass('m-menu-open');
    }
    if ($(this).next(".m-menu-content").is(':visible')) {
      $(this).next(".m-menu-content").slideUp(300);
      $(this).children(".arrow").removeClass('m-menu-open');
    } else {
      $(this).next(".m-menu-content").slideDown(300);
      $(this).children(".arrow").addClass('m-menu-open');
    }
  });  

  // footer menu accordions
  if($(window).width() < 767){
    $(".footer-section .link-wrapper .link-title").click(function () {      
      if ($('.footer-section .link-wrapper ul').is(':visible')) {
        $(".footer-section .link-wrapper ul").slideUp(300);
        $(".arrow").removeClass('m-menu-open');
      }
      if ($(this).next(".footer-section .link-wrapper ul").is(':visible')) {
        $(this).next(".footer-section .link-wrapper ul").slideUp(300);
        $(this).children(".arrow").removeClass('m-menu-open');
      } else {
        $(this).next(".footer-section .link-wrapper ul").slideDown(300);
        $(this).children(".arrow").addClass('m-menu-open');
      }
    });
    
  }

  // setInterval(function () {
  //   if($('.product-slider-thumbnail').length > 0){
  //     if($('.product-slider-thumbnail').hasClass('slick-initialized')){
        
  //     }
  //     else{
       
  //     }
  //   }
  // }, 1000);

   $('.product-slider-thumbnail').slick({
    slidesToShow: 3,
    vertical: true,
    slidesToScroll: 1,
    asNavFor: '.product-main-slider',
    arrows: true,
    dots: false,
    focusOnSelect: true
  });
  $('.product-main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    asNavFor: '.product-slider-thumbnail',
    responsive: [
      
    {
      breakpoint: 767,
      settings: {
        autoplay: true,
        autoplayspeed: 3000,
        dots: true
      }
    }
    ]
  });

  // Product main slider js start
  

  // On Product page click open image in popup
  // $(".product-main-slider").magnificPopup({
  //   delegate: "a",
  //   type: "image",
  //   gallery: {
  //     enabled: true,
  //   },
  // });

  $(".size-chart-btn").magnificPopup({
    type: 'inline',
    midClick: true,
    mainClass: 'mfp-fade'
  });

  // Marquee animation js start
  var elements = 5;
  for(var i=0;i < elements; i++){
    $(".follow-lj-wrapper .follow-lj").clone().prependTo( ".follow-lj-wrapper" );
  };
  for(var k=0;k < elements; k++){
    $(".activities-wrapper .activity").clone().prependTo( ".activities-wrapper" );
  };
  
  
});


// INSTAGRAM SLIDER
$('.main-worn-by-you-image').slick({
    infinite: true,
    slidesToShow: 3,
    arrows:false,
    arrows: true,
    slidesToScroll: 1,
    centerMode: false,
    responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
  ]
  });


  // Get the modal, button, and close elements using jQuery
  var $new_modal = $('#notifyMeModal');
  var $btn = $('#notify-me-btn');
  var $span = $('.new-close');
  
  // When the user clicks the button, open the modal
  $btn.on('click', function(e) {
    e.preventDefault();
    $new_modal.show();
    $('body').addClass('notify-popup');
  });
  
  // When the user clicks on <span> (x), close the modal
  $span.on('click', function() {
    $new_modal.hide();
    $('body').removeClass('notify-popup');
  });
  
  // When the user clicks anywhere outside of the modal, close it
  $(window).on('click', function(event) {
    if ($(event.target).is($new_modal)) {
      $new_modal.hide();
      $('body').removeClass('notify-popup');
    }
  });
// collection page tab active class start

$(document).ready(function(){
  if( $('.filter-tabing' ).length > 0 ){
    setTimeout(function() {
      let handle = $(location).attr("href").split('/').pop();
       $('.filter-tabing li a').removeClass('active');
      $('.filter-tabing li a').each(function(){
        let lia = $(this).attr('href');
        lia=lia.split('/').pop();
        console.log('vitggykgku' ,lia)
        if(handle == lia){
          $(this).addClass('active');
        }
      });
    },100);
  }

  $('.customer-testimonial').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          infinite: false,
          slidesToShow: 1.2,
          slidesToScroll: 1
        }
      }
    ]
  });

var legthArr=[];
    jQuery(document).ready(function(){
      jQuery('.customer-testimonial .testimonial-item .message ').each(function() {
          var height = jQuery(this).outerHeight();
          legthArr.push(height);
      });
      var maxValue = Math.max.apply(Math,legthArr);
      jQuery('.customer-testimonial .testimonial-item .message ').each(function() {
          jQuery(this).css('height',maxValue);
      });
   });

});

// $(document).ready(function (){
//   $('.collection-tab-section').find('.filter-tabing').find('li').on("click", function () {
//     $('.collection-tab-section').find('.filter-tabing').find('li').removeClass('active');
//     $(this).addClass('active');
//     $('#product-grid').find('.grid__item').hide();
//     var selVal = $(this).attr('data-value');
//     $('#product-grid').find('.'+selVal).show();
//   });
// });

jQuery(".product-form__buttons.product_detail_atcbtn").on("click",function(){
  var setInter = setInterval(function(){
  var attr = $('.product-form__error-message-wrapper').attr('hidden');
  if (typeof attr !== 'undefined' && attr !== false) {
    if(jQuery('.drawer.animate').hasClass('active')){
      jQuery('.drawer.animate').removeClass('active');
      clearInterval(setInter);
      jQuery('body').removeClass('overflow-hidden');
      jQuery('#view-bag-modal').addClass('is-active');
      jQuery('body').addClass('overlay-bagmodal');
      jQuery('.lookup-product-slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
           responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
          ]
        });
      }
    }
  });
});
jQuery(".view-bag-modal .close-bag-modal").on("click",function(){
  jQuery('#view-bag-modal').removeClass('is-active');
  jQuery('body').removeClass('overlay-bagmodal');
   jQuery('.drawer.animate').removeClass('active');
});

jQuery(".view-bag-modal .drawer-bag-modal").on("click",function(){
  jQuery('.drawer.animate').addClass('active');
  jQuery('#view-bag-modal').removeClass('is-active');
  jQuery('body').removeClass('overlay-bagmodal');
});

// collection page tab active class end

// PRODUCT DETAILS PAGE ACTIVE SIZE VARIANT JS START
jQuery(document).on("click",".product-form__input [name='Bottom Size']",function(e){
  var objhtml = jQuery(this);
  setTimeout(function(){
    jQuery(".product-form__input [name='Bottom Size']").each(function(){
      jQuery(this).closest('label').removeClass('active');
    });
    objhtml.closest('label').addClass('active');
    var getVals = objhtml.val();
    jQuery('.option-2.Bottom.data_clr').text(getVals);
    var getSizeTop = jQuery('.option-1.Top.Size.data_clr').text();
    if(getSizeTop!=""){
      getSizeTop = getSizeTop.toLowerCase();
      jQuery('.product-form__input [name="Top Size"][data-vid="'+getSizeTop+'"]').attr('checked');
      jQuery('.product-form__input.Top.Size').find('.'+getSizeTop).addClass('active');
    }
  },100);
  //e.preventDefault();
});
jQuery(document).on("click",".product-form__input [name='Top Size']",function(e){
  var objhtml = jQuery(this);
  setTimeout(function(){
    jQuery(".product-form__input [name='Top Size']").each(function(){
      jQuery(this).closest('label').removeClass('active');
    });
    objhtml.closest('label').addClass('active');
    var getVals = objhtml.val();
    jQuery('.option-1.Top.data_clr').text(getVals);
    var getSizeBottom = jQuery('.option-2.Bottom.Size.data_clr').text();
    if(getSizeBottom!=""){
      getSizeBottom = getSizeBottom.toLowerCase();
      jQuery('.product-form__input [name="Bottom Size"][data-vid="'+getSizeBottom+'"]').attr('checked');
      jQuery('.product-form__input.Bottom.Size').find('.'+getSizeBottom).addClass('active');
    }
  },100);
  //e.preventDefault();
});

// jQuery(document).ready(function(e){
//   if(jQuery('.product-form__input [name="Top Size"]').length>0){
//     jQuery('.product-form__input [name="Top Size"]').eq(0).trigger('click');
//   }
//   if(jQuery('.product-form__input [name="Bottom Size"]').length>0){
//     jQuery('.product-form__input [name="Bottom Size"]').eq(0).trigger('click');
//   }
//   //e.preventDefault();
// });
// PRODUCT DETAILS PAGE ACTIVE SIZE VARIANT JS END

// $(document).ready(function () {
//   function initSlider() {
//     if ($(window).width() <= 767) {
//       if (!$('.filter-tabing').hasClass('slick-initialized')) {
//         $('.filter-tabing').slick({
//           dots: false,
//           arrows: true,
//           infinite: false,
//           speed: 300,
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           responsive: [
//             {
//               breakpoint: 480,
//               settings: {
//                 slidesToShow: 1,
//                 slidesToScroll: 1
//               }
//             }
//           ]
//         });
//       }
//     } else {
//       if ($('.filter-tabing').hasClass('slick-initialized')) {
//         $('.filter-tabing').slick('unslick'); 
//       }
//     }
//   }

//   initSlider(); 

//   $(window).resize(function () {
//     initSlider(); 
//   });
// });



// $(document).ready(function () {
//   $('.collection-tab-section').find('.filter-tabing').find('li').on("click", function () {
//     $('.collection-tab-section').find('.filter-tabing').find('li').removeClass('active');
//     $(this).addClass('active');

//     $('#product-grid').find('.grid__item').hide();
//     var selVal = $(this).attr('data-value');
//     $('#product-grid').find('.' + selVal).show();

//     // Scroll the clicked item to the center
//     var $filterTabing = $('.filter-tabing');
//     var $selectedItem = $(this);
    
//     var containerWidth = $filterTabing.width();
//     var itemWidth = $selectedItem.outerWidth(true);
//     var scrollLeft = $filterTabing.scrollLeft();
//     var itemOffsetLeft = $selectedItem.position().left;

//     var newScrollLeft = scrollLeft + itemOffsetLeft - (containerWidth / 2) + (itemWidth / 2.5);
    
//     $filterTabing.animate({
//       scrollLeft: newScrollLeft
//     }, 500); 
//   });
// });
